export interface AverageTimeItem {
  icon?: string;
  // days: number;
  // hours
  time: string;
  label: string;
  color?: string;
  subItems?: AverageTimeItem[];
}
